<ng-container *ngIf="isWebView">
    <div class="responsivegrid aem-GridColumn aem-GridColumn--default--12">
        <div class="aem-Grid aem-Grid--12 aem-Grid--default--12 ">
            <div class="column-control aem-GridColumn aem-GridColumn--default--12">
                <div class="column-control-wrapper full-bleed-container layout-padding">
                    <div class="">
                        <div class="">
                            <div class="">
                                <div class="">
                                    <router-outlet></router-outlet>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="!isWebView">
    <div *ngIf="isLanding; else isNotLanding">
        <div class="responsivegrid aem-GridColumn aem-GridColumn--default--12">
            <div class="aem-Grid aem-Grid--12 aem-Grid--default--12 ">
                <div class="column-control-wrapper full-bleed-container layout-padding">
                    <div class="full-bleed-row">
                        <div class="">
                            <div *ngIf="!travelLanding" class="back-button section">
                                <div class="sub-nav breadcrumbs col-12 col-sm-12 col-md-12 col-lg-12">
                                    <ul class="nav" role="none presentation">
                                        <li class="back-button-con" role="none presentation">
                                            <button class="back-button-pdp" id="back-button-pdp" aria-label="Back to previous page" role="button" tabindex="0" data-icon="❮" (click)="backtoRewardsLanding($event)" (keypress)="backtoRewardsLanding($event)">
                                                <span class="back-button-pdp-text">Back</span>
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <router-outlet></router-outlet>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <ng-template #isNotLanding>
        <div class="responsivegrid aem-GridColumn aem-GridColumn--default--12">
            <div class="aem-Grid aem-Grid--12 aem-Grid--default--12 ">
                <div class="column-control aem-GridColumn aem-GridColumn--default--12">
                    <div class="column-control-wrapper full-bleed-container layout-padding">
                        <div class="full-bleed-row">
                            <div class="">
                                <div class="row abs-no-gutters">
                                    <div class="contentdiv col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3"
                                         [ngClass]="hideUCALeftNav ? 'mask' : 'view'">
                                        <div class="breadcrumb section">
                                            <div class="row noMargin relative">
                                                <div class="sub-nav breadcrumbs col-12 col-sm-12 col-md-12 col-lg-12"
                                                     role="navigation" aria-label="Breadcrumb">
                                                    <ul class="nav">
                                                        <li>
                                                            <a class="breadcrumb-svg-anchor-padding  body-s"
                                                               href="/rewards/dashboard"
                                                               aria-current="false">
                                                        <span class="svg-icon svg-icon-Arrow_left_breadcrumb breadcrumb-svg-arrow "
                                                              role="img" aria-hidden="true"></span>
                                                                {{displayBanner}} for U
                                                            </a>
                                                        </li>
                                                        <li class="active hide-root-title body-s body-s--semi-bold">
                                                    <span class="svg-icon svg-icon-Arrow_left_breadcrumb breadcrumb-svg-arrow hide-back-arrow"
                                                          role="img" aria-hidden="true"></span>
                                                            Rewards
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="experiencefragment section">
                                            <div class="xf-content-height">
                                                <div class="aem-Grid aem-Grid--12 aem-Grid--default--12 ">
                                                    <div class="responsivegrid aem-GridColumn aem-GridColumn--default--12">
                                                        <div class="aem-Grid aem-Grid--12 aem-Grid--default--12 ">
                                                            <left-navigation></left-navigation>
                                                        </div>
                                                    </div>


                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div class="asidediv col-12 col-sm-12 col-md-12"
                                         [ngClass]="hideUCALeftNav ? 'col-lg-12 col-xl-12' : 'col-lg-9 col-xl-9'">
                                        <router-outlet></router-outlet>
                                    </div>
                                </div>
                                <ng-container>
                                    <div id="rewardsAdBottom"> </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
</ng-container>
